//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  BASIC
} from "@/config/constant"
import promise from '@/axios/promise'
import {
  formatTime,
  guid,
  isNullOrEmptyStr,
  isNullOrEmptyArr
} from "@/utils/common"
var page = 1;
var limit = 10;
var DonePage = 1;
var DoneLimit = 10;
export default {
  data() {
    return {
      loading: false,
      refreshing: false,
      loading1: false,
      refreshing1: false,
      shift: 'movies',
      active1: 0,
      undoTasks: [],
      doneTasks: [],
      undoCount: 0,
      doneCount: 0,
      searchInfo: {
        procName: '',
        status: '',
        taskTopic: ''
      },
    }
  },
  methods: {
    refresh() {
      page = 1;
      this.loading = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': page,
            'limit': limit,
            taskType: 'undo',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.undoTasks = res.data;
          this.undoCount = res.count;
          this.loading = false;
        })
      }, 500)
    },
    doneRefresh() {
      DonePage = 1;
      this.loading1 = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': DonePage,
            'limit': DoneLimit,
            taskType: 'done',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          debugger;
          this.doneTasks = res.data;
          this.doneCount = res.count;
          this.loading1 = false;
        });
      }, 500)
    },
    load() {
      page++;
      this.loading = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': page,
            'limit': limit,
            taskType: 'undo',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.loading = false;
          this.undoCount = res.count;
          if (res.data.length != '0') {
            for (var i = 0; i < res.data.length; i++) {
              this.undoTasks.push(res.data[i])
            }
          }
        })
      }, 500)
    },
    Doneload() {
      DonePage++;
      this.loading1 = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': DonePage,
            'limit': DoneLimit,
            taskType: 'done',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.loading1 = false;
          this.doneCount = res.count;
          if (res.data.length != '0') {
            for (var i = 0; i < res.data.length; i++) {
              this.doneTasks.push(res.data[i])
            }
          }
        });
      }, 500)
    },
    taskClick: function (task, type) {
      var taskId = task.taskId;
      var taskTopic = task.taskTopic;
      var showConfirm = task.showConfirm;
      var businessKey = task.businessKey;
      var taskUrl = task.taskUrl;
      var taskDefinitionKey = task.taskDefinitionKey;
      this.$router.push({
        path: taskUrl,
        query: {
          taskTopic: taskTopic,
          taskId: taskId,
          taskType: type,
          showConfirm: showConfirm,
          businessKey: businessKey,
          taskDefinitionKey: taskDefinitionKey,
          client:'wx'
        }
      });
    },
     /*获取待办任务数据*/
    getUndoTask: function () {
      promise({
        url: BASIC + "/task/getTaskList",
        method: "get",
        params: {
          limit: 10,
          taskType: 'undo',
          taskTopic: this.searchInfo.taskTopic
        }
      }).then(res => {
        this.undoTasks = res.data;
        this.undoCount = res.count;
      });
    },
    /*获取已办任务数据*/
    getDoneTask: function () {
      promise({
        url: BASIC + "/task/getTaskList",
        method: "get",
        params: {
          limit: 10,
          taskType: 'done',
          taskTopic: this.searchInfo.taskTopic
        }
      }).then(res => {
        this.doneTasks = res.data;
        this.doneCount = res.count;
      });
    },
    taskSearch: function () {
      if (this.active1 == 0) {
        this.getUndoTask();
      } else {
        this.getDoneTask();
      }
    },
  },
  filters: {
    formatDate(time) {
      if (time == null) {
        return "";
      }
      var date = new Date(time);
      return formatTime(date, 'yyyy-MM-dd');
    },
    formatDateTime(time) {
      if (time == null) {
        return "";
      }
      var date = new Date(time);
      return formatTime(date, 'yyyy-MM-dd hh:mm:ss');
    }
  },
  created() {
    this.getUndoTask();
    this.getDoneTask();
  }
}



// WEBPACK FOOTER //
// ./src/view/wechat/taskCenter.vue